<template>
    <div class="list-group-item position-relative">
        <div class="mb-2 mb-md-0">
            <div class="row">
                <div class="col">
                    <h3 class="job-item__title">
                        {{ job.title }}
                    </h3>
                </div>
                <template v-if="attachmentFilename">
                    <div class="col-md-auto">
                        <a class="job-item__link small" :href="attachmentUrl" download @click.stop>
                            <svg class="sprite-inline mr-1" style="font-size: 1em">
                                <use href="#sprite-download" xlink:href="#sprite-download"></use>
                            </svg>
                            télécharger l'offre en pdf
                        </a>
                    </div>
                </template>
            </div>
        </div>
        <div class="mb-2">
            <template v-if="job.category">
                <span class="badge job-item__badge job-item__badge--category" :class="categoryBadgeClasses">
                    {{ job.category_label }}
                </span>
            </template>
            <template v-if="showJobContractType">
                <span class="badge badge-light job-item__badge">
                    {{ job.job_contract_type_label }}
                </span>
            </template>
        </div>
        <div class="text-muted small mb-1">
            <a :href="directoryCardUrl" style="color: inherit">{{ directoryCardName }}</a> <span class="mx-1">•</span> {{ job.city }} ({{ job.department }})
        </div>

        <div class="d-none d-md-block mb-1 small">
            <JobOfferInfos :job="job" />
        </div>

        <template v-if="showDescription && job.short_description">
            <div>
                <a class="small text-muted" style="text-decoration: underline" href="#" @click.prevent v-b-toggle="collapseId">
                    en savoir
                    <svg class="sprite-inline align-middle" style="font-size: .5em">
                        <use href="#sprite-plus" xlink:href="#sprite-plus"></use>
                    </svg>
                </a>
                <b-collapse class="mx-n3 mb-n2" style="min-height: .5rem" :id="collapseId">
                    <div class="pt-3">
                        <div class="bg-light p-3 small">
                            <div v-html="job.short_description">
                            </div>
                            <JobOfferInfos class="d-md-none mt-2" :job="job" />
                        </div>
                    </div>
                </b-collapse>
            </div>
        </template>
        <slot />
        <template v-if="href">
            <a :href="href" class="stretched-link"></a>
        </template>
    </div>
</template>

<script>
    import { BCollapse, VBToggle } from 'bootstrap-vue';
    import { fileName } from "../../../util/file";
    import JobOfferInfos from "./JobOfferInfos.vue";

    export default {
        components: {
            BCollapse,
            JobOfferInfos,
        },
        props: {
            job: {
                type: Object,
                required: true,
            },
            showDescription: {
                type: Boolean,
                default: true,
            },
            href: String,
        },
        computed: {
            attachmentUrl() {
                return `/annonces/${this.job.id}/telechargement`;
            },
            attachmentFilename() {
                return fileName(this.job.attachment?.file_name);
            },
            collapseId() {
                return `joboffer-${this.job.id}`;
            },
            showJobContractType() {
                return this.job.category === 'JOB' && !!this.job.job_contract_type;
            },
            categoryBadgeClasses() {
                return {
                    'bg-white border-primary': this.job.category === 'JOB',
                    'job-item__badge--grey': this.job.category === 'CALL_FOR_PROJECTS',
                }
            },
            directoryCardName() {
                return this.job.directoryCard.name;
            },
            directoryCardUrl() {
                return this.job.directoryCard.url;
            },
        },
        directives: {
            'b-toggle': VBToggle,
        },
    }
</script>
